module.exports = __webpack_public_path__ + "static/media/red-spot.2343dce1.png";